import { Badge, BadgeProps } from "@adfenix/alexandria";
import { PropertyService } from "@adfenix/types";
import { TFunction } from "i18next";
import styled from "styled-components";

interface OwnProps extends BadgeProps {
  title: string;
}
type statusMapType = {
  [type in PropertyService.PropertyReadLayerStatus]: OwnProps;
};

type RadiusSettings = "all" | "right";
const StyledBadge = styled(Badge)<{ borderRadius: RadiusSettings }>`
  border-radius: ${({ borderRadius }) =>
    borderRadius === "right" ? "0 4px 4px 0;" : "4px;"};
  margin-right: 8px;
`;

const ListingStatus = ({
  status,
  t,
  borderRadius = "right"
}: {
  status: PropertyService.PropertyReadLayerStatus | undefined;
  t: TFunction;
  borderRadius?: RadiusSettings;
}) => {
  if (!status) {
    return null;
  }

  const basePath = "listings.listing.status";
  const statusMap: statusMapType = {
    Unpublished: {
      color: "grey",
      title: t(`${basePath}.unpublished`)
    },
    Upcoming: {
      color: "warning",
      title: t(`${basePath}.upcoming`)
    },
    ForSale: {
      color: "success",
      title: t(`${basePath}.forSale`)
    },
    Sold: {
      color: "black",
      title: t(`${basePath}.sold`)
    },
    Removed: {
      color: "danger",
      title: t(`${basePath}.removed`)
    },

    Unknown: {
      color: "grey",
      title: "No status",
      lightness: "darker"
    }
  };

  const { color, title } = statusMap[status] || {
    title: "No status",
    color: "grey",
    lightness: "darker"
  };

  return (
    <StyledBadge
      color={color}
      lightness="darker"
      borderRadius={borderRadius}
      data-testid="listing-status"
    >
      {title}
    </StyledBadge>
  );
};
export default ListingStatus;
